import React from "react";
import TableBody from "../../../../../ui/widgets/table/body";
import TableCell from "../../../../../ui/widgets/table/cell";
import TableRow from "../../../../../ui/widgets/table/row";
import { BodyProps } from "./types";
import { useMessageSource } from "react-message-source";

export default function Body({ rows, columns }: BodyProps): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <TableBody>
      {rows.length > 0 ? (
        rows.map((row) => {
          return (
            <TableRow key={row.id}>
              {columns.map((col) => (
                <TableCell key={col}>{row[col]}</TableCell>
              ))}
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <TableCell className="scd-table-no-data">
            {getMessage("Dashboard.no-rows-found")}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
}
